/* eslint-disable no-console */

import { BaseLogger } from './base.ts';
import type { LogLevel, Data } from './index.ts';
import { captureException } from './sentry.ts';

export class ClientLogger extends BaseLogger {
  protected exec(level: LogLevel, message: unknown, data?: Data) {
    if (data) {
      console[level](message, data);
    } else {
      console[level](message);
    }

    if (level === 'error' || level === 'warn') {
      captureException(level, message, data);
    }
  }
}
